export default "__VITE_ASSET__jOX8L4prGHllqMtq8nsjgQ__"